import { useEffect } from 'react'
import { CookiesProvider } from 'react-cookie'
import { useLocation } from 'react-router'
import { ToastContainer } from 'react-toastify'
import { nb } from 'date-fns/locale'
import CssBaseline from '@mui/material/CssBaseline'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ThemeContextProvider } from './components/Context/ThemeContextProvider'
import { MainRouter } from './MainRouter'

export const App = () => {
  const location = useLocation()
  useEffect(() => {
    if ('FreshworksWidget' in window) {
      window.FreshworksWidget('prefill', 'ticketForm', {
        custom_fields: {
          cf_url: location.pathname,
        },
      })
    }
  }, [location])

  return (
    <ThemeContextProvider>
      <CssBaseline enableColorScheme />
      <CookiesProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
          <MainRouter />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            className={'toast-vessel'}
          />
        </LocalizationProvider>
      </CookiesProvider>
    </ThemeContextProvider>
  )
}
